import React, { useEffect, useRef, useState } from "react";
import BookMarksVM from "./BookMarksVM";
import "./style.scss"

const BookMarkWidget = ({ view, activeWidget,mapId }) => {
  const [visible, setVisible] = useState(false);
  const bookmarkWidgetDiv = useRef(null);
  let bookmarkWidget;

  useEffect(() => {
    if (activeWidget === "bookmarks") {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [activeWidget]);

  let style = { display: "initial" };
  if (visible) {
    style.display = "initial";
  } else {
    style.display = "none";
  }

  useEffect(() => {
    if (bookmarkWidgetDiv.current) {
      BookMarksVM(view, bookmarkWidgetDiv.current,mapId).then((bookmark) => {
        bookmarkWidget = bookmark;
      });
    }
    return () => {
      bookmarkWidget.destroy();
    };
  }, []);

  return <div ref={bookmarkWidgetDiv} style={style}></div>;
};

export default BookMarkWidget;
